/**
 * Nome da sessão do Supabase no storage (localStorage, cookie SSO do domínio
 * pai e Keychain/Keystore no app nativo).
 *
 * Sem configuração o supabase-js deriva o nome do host da API:
 * `sb-<1º rótulo do host>-auth-token`. Em PROD na Supabase Cloud isso dá
 * `sb-ttttxnptrhxmhmsiyxtm-auth-token`; com a API em
 * `https://api.playprosport.com.br` daria `sb-api-auth-token` — e todo mundo
 * perderia a sessão no dia da troca de URL, mesmo com os sites no mesmo domínio.
 *
 * `VITE_SUPABASE_AUTH_STORAGE_KEY` fixa o nome. Vale para TODOS os apps de um
 * ambiente com o MESMO valor: o SSO web entre www/crm/admin é o mesmo cookie
 * no domínio pai, e o cookie tem o nome desta chave. HML e PROD dividem o
 * domínio pai (`.playprosport.com.br`), então o valor de um ambiente NUNCA
 * pode ser repetido no outro (um sobrescreveria a sessão do outro).
 *
 * Sem a variável o comportamento é idêntico ao de antes (nome derivado).
 */

/** Só caracteres seguros como nome de cookie e de chave de storage. */
const FORMATO = /^[A-Za-z0-9_-]{1,128}$/;

export function chaveDaSessaoDoAmbiente(valor: string | null | undefined): string | undefined {
  const v = (valor ?? "").trim();
  if (!v) return undefined;
  if (!FORMATO.test(v)) {
    // Falha alto: cair no nome derivado em silêncio deslogaria todo mundo.
    throw new Error(
      `[@pps/auth-client] VITE_SUPABASE_AUTH_STORAGE_KEY inválida: use só letras, números, "-" e "_" (recebido: ${JSON.stringify(v)}).`
    );
  }
  return v;
}
